import React from 'react';
import './ServiceSingle.css';

/* Usunięto Lightbox z importów */
import { PageTitle, SidebarHeading } from '../../../components';
import { services } from '../../../constants';
import { renderIcon } from '../../../utils';

import { FaCheck, FaInfoCircle } from 'react-icons/fa';
import { Link, useLocation, useParams } from 'react-router-dom';

const toSlug = (text) =>
    text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');

const ServiceSingle = () => {

    const location = useLocation();
    const { id } = useParams();
    const stateService = location.state;

    const serviceFromParam = services.find((service) => {
        if (!id) return false;

        const byNumericId = Number.isInteger(Number(id)) && service.id === Number(id);
        const bySlug = toSlug(service.title) === toSlug(id);

        return byNumericId || bySlug;
    });

    const serviceSingle = stateService || serviceFromParam;

    if (!serviceSingle) {
        return <div>Ładowanie... lub nie znaleziono usługi.</div>;
    }

    const features = serviceSingle.features;
    const paragraphs = serviceSingle.paragraphs;

    return (
        <>
            {/* Page Title */}
            <PageTitle title={serviceSingle.title} page={'Oferta'} />

            <section className='service-single page-single'>

                {/* --- LEWA KOLUMNA (SIDEBAR) --- */}
                <div className='sidebar service-sidebar'>

                    <div className='category sidebar-item'>

                        <SidebarHeading title={'Wszystkie usługi'} />

                        <div className='box-container'>
                            {services.map(service => {
                                return (
                                    <Link
                                        to={`/Uslugi/${service.id}`}
                                        state={service}
                                        key={service.id}
                                        className={`item ${service.id === serviceSingle.id ? 'active' : ''}`}
                                    >
                                        <span>
                                            <div className='icon'>{renderIcon(service.title)}</div>
                                            {service.title}
                                        </span>
                                    </Link>)
                            })}
                        </div>

                    </div>

                </div>

                {/* --- PRAWA KOLUMNA (TREŚĆ) --- */}
                <div className='service-info page-info'>

                    {/* Zdjęcie główne */}
                    <div className='image'>
                        <img src={serviceSingle.image} alt={serviceSingle.title} />
                    </div>

                    <div className='content'>

                        {/* Tytuł usługi */}
                        <h3 className='main-heading'>{serviceSingle.title}</h3>

                        {/* Wstęp */}
                        <p className='service-intro'>{serviceSingle.content}</p>

                        {/* Lista punktowana (paragraphs) */}
                        <div className='service-benefits'>
                            <ul>
                                {paragraphs.map((paragraph, index) => (
                                    <li key={index}>
                                        <FaCheck className='icon' />
                                        {paragraph}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Dodatkowe informacje (features) */}
                        {features && (
                            <div className='service-features-highlight'>
                                <div className='feature-box'>
                                    <FaInfoCircle className='icon-large' />
                                    <div>
                                        <h4 className='sub-heading-small'>Dodatkowe informacje</h4>
                                        <p>{features}</p>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>

                </div>

            </section>
        </>
    );
}

export default ServiceSingle;